import React from 'react';
import { useTranslation } from 'react-i18next';

const TeamDetailsSec = ({ className = "space overflow-hidden" }) => {
  const { t } = useTranslation();
  return (
    <section className={className}>
      <div className="container">
        <div className="team-details-wrap" data-cue="slideInUp">
          <div className="box-img">
            <img src="assets/img/team/team_inner_1.jpg" alt={t('sections.teamDetailsSec.name','Justine Kingdony')} />
          </div>
          <div className="box-content">
            <h2 className="page-title">{t('sections.teamDetailsSec.name','Justine Kingdony')}</h2>
            <p className="page-desig">{t('sections.teamDetailsSec.designation','UI/UX Designer')}</p>
            <p className="page-content">{t('sections.teamDetailsSec.bio','John is a seasoned cybersecurity expert with over 20 years of experience in the industry, possessing a deep understanding of the evolving cyber threat landscape. His expertise lies in identifying, analyzing, and mitigating advanced threats to ensure the security.')}</p>
            <div className="team-info-wrap">
              <div className="team-info">
                <div className="box-icon icon-btn" data-theme-color="#069845">
                  <i className="far fa-user"></i>
                </div>
                <div className="media-body">
                  <h4 className="box-title">{t('sections.teamDetailsSec.experience_label','Experience')}</h4>
                  <p className="box-text">{t('sections.teamDetailsSec.experience_value','More Than 15 Years')}</p>
                </div>
              </div>
              <div className="team-info">
                <div className="box-icon icon-btn" data-theme-color="#F0A230">
                  <i className="far fa-envelope"></i>
                </div>
                <div className="media-body">
                  <h4 className="box-title">{t('sections.teamDetailsSec.email_label','Email')}</h4>
                  <p className="box-text">
                    <a href="mailto:enfo@secur.com">{t('sections.teamDetailsSec.email_value','Enfo@secur.com')}</a>
                  </p>
                </div>
              </div>
              <div className="team-info">
                <div className="box-icon icon-btn" data-theme-color="#E0009B">
                  <i className="far fa-phone"></i>
                </div>
                <div className="media-body">
                  <h4 className="box-title">{t('sections.teamDetailsSec.phone_label','Phone')}</h4>
                  <p className="box-text">
                    <a href="tel:+165-5577-8749">{t('sections.teamDetailsSec.phone_value','+165-5577-8749')}</a>
                  </p>
                </div>
              </div>
              <div className="team-info">
                <div className="box-icon icon-btn" data-theme-color="#8F54FF">
                  <i className="far fa-address-book"></i>
                </div>
                <div className="media-body">
                  <h4 className="box-title">{t('sections.teamDetailsSec.address_label','Address')}</h4>
                  <p className="box-text">{t('sections.teamDetailsSec.address_value','932 Dogwood Road, Chapel')}</p>
                </div>
              </div>
            </div>
            <div className="ot-social">
              <span>{t('sections.teamDetailsSec.follow_label','Follow On:')}</span>
              <a target="_blank" href="https://facebook.com/" rel="noopener noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a target="_blank" href="https://twitter.com/" rel="noopener noreferrer">
                <i className="fab fa-twitter"></i>
              </a>
              <a target="_blank" href="https://linkedin.com/" rel="noopener noreferrer">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a target="_blank" href="https://instagram.com/" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamDetailsSec;